// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1yOND","col":"Table_col__gVdmA","fulfillmentStatus":"Table_fulfillmentStatus__3FddF","emailCol":"Table_emailCol__3jGsw"};